import { createGlobalStyle } from 'styled-components';

// eslint-disable-next-line zillow/@typescript-eslint/naming-convention
const GlobalStyle = createGlobalStyle`
    *,
    :after,
    :before {
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;
    }
`;

export default GlobalStyle;
